<template>
  <transition name="slide">
    <div
      class="drawer"
      v-show="drawer"
      @click="closeDrawer"
      v-if="cliente && cliente.cpf">
      <nav @click.stop="">
        
        <MenuItems />
      </nav>
    </div>
  </transition>
</template>
<script>
import MenuItems from "./MenuItems.vue";
import "vue-select/dist/vue-select.css";

export default {
  filters: {
    formatCPF(value) {
      return formatCPF(value);
    },
  },
  components: {
    MenuItems,
  },
  data() {
    return {};
  },
  computed: {
    fornecedor() {
      let fornecedor = this.$store.state.SolicitacaoPagamento.fornecedor;
      let access_token = fornecedor.token;
      if (!access_token) {
        return null;
      }
      return fornecedor;
    },
    vinculo_id: {
      get() {
        return this.$store.state.vinculo_id;
      },
      set(value) {
        this.$store.dispatch("setVinculoId", value);
      },
    },
    drawer() {
      return this.$store.state.drawer;
    },
    cliente() {
      return this.$store.state.cliente;
    },
    vinculos() {
      return this.$store.getters.vinculos;
    },
    relacao() {
      return this.$store.getters.relacao;
    },
    relacao_id: {
      get() {
        return +this.$store.state.relacao_id;
      },
      set(value) {
        this.$store.dispatch("setRelacaoId", value);
        this.$router.replace("/");
      },
    },
  },
  methods: {
    logoutFornecedor() {
      this.$store.state.SolicitacaoPagamento.fornecedor = {};
      this.$router.push({
        path: "/solicitacao-de-pagamento/busca-fornecedor",
      });
    },
    closeDrawer() {
      this.$store.dispatch("hideDrawer");
    },
    async logout() {
      try {
        await Promise.all([
          this.$store.dispatch("setCliente", {}),
          this.$store.dispatch("setRelacoes", []),
          this.$store.dispatch("setRelacaoId", 0),
          this.$store.dispatch("setCondominioId", 0),
          this.$store.dispatch("setContratoId", 0),
          this.$store.dispatch("setImovelId", 0),
          this.$store.dispatch("setRefreshToken", null),
          this.$store.dispatch("setJwt", null),
        ]);

        this.$router.replace("/login");
      } catch (error) {
        console.error(error);
      }
    },
    alterarVinculo() {},
  },
  watch: {
    vinculos: {
      immediate: true,
      handler() {
        if (this.vinculos.length == 0) {
          return;
        }
      },
    },
  },
};
</script>
<style lang="less">
h3 {
  span {
    color: white;
  }
}

.drawer {
  grid-area: drawer;
  z-index: 3;
  position: absolute;
  top: 90px;
  right: 0;
  height: 100vh;
  width: 100vw;
  color: white;
  background-color: #eeeeee;
  padding-bottom: 100px;

  nav {
    z-index: 3;
    position: relative;
    /*padding: 1em;*/
    height: 100%;
    overflow-y: auto;

    @media (max-width: 40em) {
      height: ~"calc(100vh - 56px)";
    }

    & {
      -ms-overflow-style: none;
      /* Internet Explorer 10+ */
      scrollbar-width: none;
      /* Firefox */
    }

    &::-webkit-scrollbar {
      display: none;
      /* Safari and Chrome */
    }

    &:hover {
      &::-webkit-scrollbar {
        display: block;
        width: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.5);
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        a {
          display: block;
          padding: 1em;
          text-decoration: none;
          color: white;
        }
      }
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.25s ease-in-out;
}

.slide-enter {
  transform: translateX(80vw);
}

.slide-enter-to {
  transform: translateX(0);
}

.slide-leave {
  transform: translateX(0);
}

.slide-leave-to {
  transform: translateX(80vw);
}
</style>
<style lang="less">
.drawer {
  nav {
    .v-select {
      padding: 0 !important;

      * {
        color: white;
      }

      .vs__dropdown-toggle {
        border-color: rgba(255, 255, 255, 0.5);
        border-radius: 0;
      }
    }

    & > ul {
      margin-bottom: 6em;
    }
  }
}
</style>
